import React from "react";
import { icons } from "lucide-react";

function toPascal(name) {
  if (!name) return "CircleCheck";
  return name
    .split("-")
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join("");
}

export default function Icon({ name, className, ...props }) {
  const Cmp = icons[toPascal(name)] || icons["CircleCheckBig"] || icons["Sprout"];
  return <Cmp className={className} {...props} />;
}
